/* istanbul ignore file */
export * from './ProductCategoryNavigationDesktop';
